import { InferenceType } from "@/lib/playground-utils";
import Inference from "./inference";
import { useEffect, useRef } from "react";

export default function PlaygroundInferences({
  inferences,
}: {
  inferences: InferenceType[];
}) {
  const firstInferenceRef = useRef<HTMLDivElement>(null);
  const prevInferenceCount = useRef(inferences.length);

  useEffect(() => {
    // If a new inference was added, check if it's in view before scrolling
    if (inferences.length > prevInferenceCount.current && firstInferenceRef.current) {
      const rect = firstInferenceRef.current.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
      
      // Only scroll if the new inference is completely out of view
      if (!isInView) {
        firstInferenceRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'end' 
        });
      }
    }
    prevInferenceCount.current = inferences.length;
  }, [inferences.length]);

  return (
    <div>
      {inferences.length > 0 && (
        <div className="mt-8">
          <h3 className="text-lg font-medium mb-4">Results</h3>
          <div className="flex flex-col gap-4">
            {inferences.map((inference, index) => (
              <div
                key={inference.id}
                ref={index === 0 ? firstInferenceRef : null}
              >
                <Inference {...inference} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
